import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { useParams } from "react-router-dom";


const ViewBlog = () => {

  const { id } = useParams();
   const baseurl = process.env.REACT_APP_BASE_URL;
    const imgurl = process.env.REACT_APP_IMAGE_URL;
    const [editData, setEditData] = useState([]);
      const [error, setError] = useState(null);

    useEffect(async () =>  {
        try {
                setError(null);
                const response = await fetch(`${baseurl}/admin/blogs/${id}`);
                if (!response.ok) throw new Error("Network response was not ok");
                const data = await response.json();
                setEditData(data);
               
              } catch (error) {
                setError(error.message);
              }
          
        
      }, [id]);
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Blog" breadcrumbItem="Blog Details" />
          
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="pt-3">
                    <div className="row justify-content-center">
                      <div className="col-xl-8">
                        <div>
                          <div className="text-left">
                            <h4>{editData?.title}</h4>
                            <p className="text-muted mb-4">
                              <i className="mdi mdi-calendar me-1"></i> {editData?.cdate}
                            </p>
                          </div>

                          <hr />
                          <div className="text-center">
                            <Row>
                              <Col sm={4}>
                                <div>
                                  <p className="text-muted mb-2">Categories</p>
                                  <h5 className="font-size-15">{editData?.category}</h5>
                                </div>
                              </Col>
                              <Col sm={4}>
                                <div className="mt-4 mt-sm-0">
                                  <p className="text-muted mb-2">Date</p>
                                  <h5 className="font-size-15">10 Apr, 2020</h5>
                                </div>
                              </Col>
                              <Col sm={4}>
                                <div className="mt-4 mt-sm-0">
                                  <p className="text-muted mb-2">Post by</p>
                                  <h5 className="font-size-15">
                                    Gilbert Smith
                                  </h5>
                                </div>
                              </Col>
                            </Row>
                          </div>
                          <hr />

                          <div className="my-5">
                            <img
                              src={imgurl + editData?.blog_img}
                              alt=""
                              className="img-thumbnail mx-auto d-block"
                            />
                          </div>

                          <hr />

                          <div className="mt-4">
                            <div className="text-muted font-size-14"
  dangerouslySetInnerHTML={{
    __html: editData?.blog_discription || ""
  }}
></div>
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>

              <Card>
            <CardBody>
              <CardTitle className="h4 mb-3">Meta Data</CardTitle>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Meta Title</Label>
                    <p>{editData?.meta_title}</p>
                  </FormGroup>

                  <FormGroup>
                    <Label>Meta Keywords</Label>
                    <p>{editData?.meta_keywords}</p>
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label>Meta Description</Label>
                     <p>{editData?.meta_description}</p>
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default ViewBlog;
